import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

/**
 * ThematicPageCardBlock - Carte cliquable vers page thématique
 * 
 * Props:
 * - block: {
 *     content: {
 *       label: "Carte Précommandes" (admin only),
 *       title: "Précommandes",
 *       background_type: "color" | "image",
 *       background_color: "#FF0000",
 *       background_image_url: "https://...",
 *       target_page_id: "page-precommandes",
 *       button_text: "Voir les précommandes",
 *       custom_link: "/dashboard/precommandes"
 *     }
 *   }
 */
const ThematicPageCardBlock = ({ block }) => {
  const navigate = useNavigate();
  const {
    title = 'Page thématique',
    background_type = 'color',
    background_color = '#6366f1',
    background_image_url,
    button_text = 'Découvrir',
    custom_link = '#',
    description
  } = block.content || {};

  // Gérer le clic
  const handleClick = (e) => {
    e.preventDefault();
    if (custom_link && custom_link !== '#') {
      navigate(custom_link);
    }
  };

  // Style de fond
  const backgroundStyle = background_type === 'image' && background_image_url
    ? {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${encodeURI(decodeURI(background_image_url))})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    : {
        backgroundColor: background_color
      };

  return (
    <div
      className="rounded-2xl overflow-hidden p-6 md:p-8 flex flex-col justify-between min-h-[250px] md:min-h-[300px] text-white cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-2xl w-full"
      style={backgroundStyle}
      onClick={handleClick}
      data-testid="thematic-page-card"
    >
      {/* Contenu */}
      <div className="flex-1 flex flex-col justify-between">
        {/* Titre */}
        <h3 className="text-2xl md:text-3xl font-bold mb-3 break-words whitespace-normal">
          {title}
        </h3>

        {/* Description optionnelle */}
        {description && (
          <p className="text-sm md:text-base opacity-90 mb-4 break-words whitespace-normal">
            {description}
          </p>
        )}

        {/* Spacer */}
        <div className="flex-1"></div>

        {/* Bouton */}
        <div className="mt-4">
          <Button
            variant="secondary"
            className="bg-white text-gray-900 hover:bg-gray-100 px-6 py-3 rounded-lg font-semibold shadow-lg transition-all duration-200 w-full sm:w-auto max-w-full break-words whitespace-normal"
            data-testid="thematic-card-button"
          >
            {button_text}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThematicPageCardBlock;
